<template>
  <b-modal :active.sync="isModalActive" :can-cancel="['x']">
    <div class="w-auto border rounded border-blue-light">
      <header class="w-full px-4 py-2 text-xl font-thin uppercase bg-grey-lightest text-blue-light">
        {{ $t('add_ifc') }}
      </header>

      <div class="w-full p-8 text-center bg-grey-lightest">
        <div class="mb-4">
          <b-upload v-model="file" :multiple="false" accept=".ifc"
            class="w-full justify-center">
            <div class="flex justify-center">
              <div class="p-8 text-center text-grey">
                <p class="m-4">
                  <b-icon pack="fas" icon="upload" size="is-large" />
                </p>
                <p>{{ $t("drop_files") }}</p>
              </div>
            </div>
          </b-upload>
        </div>

        <div v-if="file">
          <div class="mb-2">{{ file.name }}</div>
        </div>

        <div v-if="isSubmitting" class="mb-2">
          <progress :value="uploadPercentage" max="100" class="w-full"></progress>
        </div>

        <div class="flex justify-end items-center">
          <a class="pr-4" @click="hide" :disabled="isSubmitting">{{ $t("close") }}</a>
          <button class="button is-primary mr-2" :disabled="!file || isSubmitting" @click="onClickUpload">
            {{ $t("upload") }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Uppy from "@uppy/core";
// import AwsS3Multipart from "@uppy/aws-s3-multipart";
import AwsS3 from "@uppy/aws-s3";
import { mapGetters } from "vuex";
import store from "~/store";

export default {
  name: "upload-ifc-document",
  data: () => ({
    isModalActive: false,
    file: null,
    isSubmitting: false,
    uploadPercentage: 0,
    uppy: null,
    currentFileKey: null,
  }),

  computed: {
    ...mapGetters({
      project: "app/project",
    }),
  },

  created() {
    this.uppy = new Uppy({
      debug: process.env.NODE_ENV === "development",
      autoProceed: false,
      allowMultipleUploads: false,
    }).use(AwsS3, {
      shouldUseMultipart: true,
      limit: 3,
      companionUrl: '/api/v2/',
      endpoint: '/api/v2/',
      headers: {
        'Authorization': "Bearer " + store.getters["auth/token"]
      }
    });

    this.uppy.on("upload-progress", (file, progress) => {
      this.uploadPercentage = parseInt(Math.round((progress.bytesUploaded * 100) / progress.bytesTotal));
    });

    this.uppy.on("upload-error", (file, error) => {
      console.error("Upload error", error);
    });
  },

  methods: {

    show() {
      this.isModalActive = true;
      this.resetState();
    },

    hide() {
      this.resetState();
      this.isModalActive = false;
    },

    resetState() {
      this.file = null;
      this.isSubmitting = false;
      this.uploadPercentage = 0;
      if (this.currentFileKey) {
        try { this.uppy.removeFile(this.currentFileKey); } catch (e) {}
        this.currentFileKey = null;
      }
    },

    async onClickUpload() {
      if (!this.file) return;
      this.isSubmitting = true;
      this.uploadPercentage = 0;

      try {
        if (this.currentFileKey) this.uppy.removeFile(this.currentFileKey);

        this.currentFileKey = this.uppy.addFile({
          name: this.file.name,
          type: this.file.type,
          data: this.file,
          source: "Local",
        });

        const result = await this.uppy.upload();

        if (result.successful && result.successful.length > 0) {
          const resp = result.successful[0].response;
          const key = resp && resp.body && resp.body.key ? resp.body.key : null;

          if (!key) {
            throw new Error("No AWS key returned");
          }

          const name = this.file.name

          const url = `/api/v2/project/${this.project.id}/ifc-document`;
          const postResp = await axios.post(url, { ifcpath: key, name: name });

          if (postResp && postResp.data && postResp.data.success) {
            this.$emit("success");
            this.hide();
          } else {
            throw new Error("Server returned error");
          }
        } else {
          throw new Error("Upload failed");
        }
      } catch (err) {
        console.error(err);
        this.$notify.error("Error al subir fichero");
      } finally {
        this.isSubmitting = false;
        this.uploadPercentage = 0;
      }
    },
  },
};
</script>

<style scoped>
.w-full { width: 100%; }
.button { cursor: pointer; }
</style>
